import styled from '@emotion/styled';

const ProductIcon = styled.svg`
  label: FanProductIcon;

  height: 2.5rem;
  width: 3.25rem;
  stroke: var(--colors-white);
  stroke-width: 0.15rem;
`;

export default ProductIcon;
